module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanBadger_j_albino.5dfeabb2.png";